import { Labels, METRIC_NAME_LABEL_KEY } from '@/core';

/**
 * Removes labels that have the same value across all series in the dataset.
 */
export function filterCommonLabels({
  seriesName,
  labels,
  commonLabels,
}: {
  seriesName: string;
  labels: Labels | undefined;
  commonLabels: Record<string, string> | undefined;
}): string {
  if (!commonLabels || !labels || Object.keys(commonLabels).length === 0) {
    return seriesName;
  }

  // Extract metric name from labels
  const metricName = labels[METRIC_NAME_LABEL_KEY];

  // Build label pairs excluding common labels
  const labelPairs: string[] = [];
  for (const [labelName, labelValue] of Object.entries(labels)) {
    // Skip __name__ (handled separately as metric prefix) and common labels
    if (labelName === METRIC_NAME_LABEL_KEY) continue;
    if (Object.hasOwn(commonLabels, labelName)) continue;

    labelPairs.push(`${labelName}="${labelValue}"`);
  }

  // Format the series name
  if (metricName) {
    return labelPairs.length > 0 ? `${metricName}{${labelPairs.join(',')}}` : metricName;
  }
  return labelPairs.length > 0 ? `{${labelPairs.join(',')}}` : seriesName;
}
